<section class="p-relative">
  <div class="row">
    <div class="col-12 col-xl-6">
      <h5>Summary</h5>

      <div class="card-wrapper">
        <app-data-card-group>
          <div class="row g-0">
            <div class="col-12 col-lg-6 col-xl-12 col-xxl-6">
              <app-data-card header="Tax position">
                <ng-container slot="content">
                  {{taxSummary.projectedTaxPosition | customCurrency}}
                  <app-comparison-arrow [a]="isActuals ? taxSummaryActual.projectedTaxPosition : taxSummaryForecast.projectedTaxPosition"
                    [b]="isActuals ? taxSummaryForecast.projectedTaxPosition : taxSummaryActual.projectedTaxPosition"
                    [isInverted]="true">
                  </app-comparison-arrow>
                </ng-container>

                @if (taxSummaryForecast.projectedTaxPosition) {
                  <ng-container slot="footer">
                    Actual Tax position is
                    {{taxSummaryActual.projectedTaxPosition > taxSummaryForecast.projectedTaxPosition ? 'up' : 'down'}}
                    by
                    {{((taxSummaryActual.projectedTaxPosition - taxSummaryForecast.projectedTaxPosition) / taxSummaryForecast.projectedTaxPosition) | abs | percent:'1.0-0'}}
                  </ng-container>
                }

                @if (!taxSummaryForecast.projectedTaxPosition) {
                  <ng-container slot="footer">
                    No prior year comparison
                  </ng-container>
                }
              </app-data-card>
            </div>

            <div class="col-12 col-lg-6 col-xl-12 col-xxl-6">
              <app-data-card header="Tax %">
                <ng-container slot="content">
                  {{taxSummary.taxPercent | percent:'1.0-2'}}
                  <app-comparison-arrow [a]="isActuals ? taxSummaryActual.taxPercent : taxSummaryForecast.taxPercent"
                    [b]="isActuals ? taxSummaryForecast.taxPercent : taxSummaryActual.taxPercent"
                    [isInverted]="true">
                  </app-comparison-arrow>
                </ng-container>

                @if (taxSummaryForecast.taxPercent) {
                  <ng-container slot="footer">
                    Actual Tax position is
                    {{taxSummaryActual.taxPercent > taxSummaryForecast.taxPercent ? 'up' : 'down'}}
                    by
                    {{((taxSummaryActual.taxPercent - taxSummaryForecast.taxPercent) / taxSummaryForecast.taxPercent) | abs | percent:'1.0-0'}}
                  </ng-container>
                }

                @if (!taxSummaryForecast.taxPercent) {
                  <ng-container slot="footer">
                    No prior year comparison
                  </ng-container>
                }
              </app-data-card>
            </div>
          </div>
        </app-data-card-group>
      </div>
    </div>

    <div class="col-12 col-xl-6">
      <app-pie-chart
        [data]="chartData"
        bindSeriesName="name"
        bindValue="data">
      </app-pie-chart>
    </div>
  </div>
</section>
